import * as React from 'react'

import type { Collection } from 'modules/core/lib/mobx-rest'
import type { Model } from 'modules/core/lib/mobx-rest'

export default function createCollectionContext<M extends Model, C extends Collection<M>>() {
  const Context = React.createContext<C | null>(null)

  const provider = ({
    collection,
    children,
  }: {
    collection: C
    children: any // FIXME: [ts-migration] This was a React.Node but now is an any
  }) => <Context.Provider value={collection}>{children}</Context.Provider>

  const useHook = (): C => {
    const models = React.useContext(Context)

    if (!models) {
      throw new Error('Collection hook must be used within a collection provider')
    }

    return models
  }

  return {
    provider,
    hook: useHook,
  }
}
